"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_jss_1 = require("react-jss");
const classnames_1 = __importDefault(require("classnames"));
const _1 = __importStar(require("../."));
const DefaultDeleteIcon = react_1.default.createElement("div", { style: { fontSize: '2em', transform: 'translateY(-0.14em)' } }, "\u2A2F");
const FieldGroup = ({ value = [{}], setValue, name, mandatory, fields, moreComponent, moreComponentProps, customMoreLabel, deleteIcon = DefaultDeleteIcon, children: Children, }) => {
    const classes = useStyles();
    const theme = (0, react_jss_1.useTheme)();
    const MoreComponent = moreComponent || _1.Button;
    const moreLabel = customMoreLabel || theme.textLabels.addMore;
    const [renderItems, setRenderItems] = react_1.default.useState(true);
    // Use ref to let values in handleChange function be always up to date.
    const valueRef = react_1.default.useRef(value);
    const invalidRowsRef = react_1.default.useRef([]);
    const updateValue = (newValue, options) => {
        setValue(name, newValue, mandatory, options);
        valueRef.current = newValue;
    };
    const updateValidation = (rowHasErrors, rowIndex) => {
        if (rowHasErrors) {
            // Add this row to invalid rows array, but keep it without duplicates.
            const uniqueArray = [...new Set([...invalidRowsRef.current, rowIndex])];
            return uniqueArray;
        }
        else {
            return invalidRowsRef.current.filter((item) => item !== rowIndex);
        }
    };
    const handleChange = (updatedFields, rowHasErrors, rowIndex) => {
        const updatedValidation = updateValidation(rowHasErrors, rowIndex);
        invalidRowsRef.current = updatedValidation;
        updateValue(valueRef.current.map((item, subIndex) => rowIndex !== subIndex ? item : updatedFields), {
            forceErrorMessage: updatedValidation.length
                ? theme.textLabels.fieldgroupInvalid
                : false,
        });
    };
    const handleDelete = (e, rowIndex) => __awaiter(void 0, void 0, void 0, function* () {
        e.preventDefault();
        // Force rerender to prevent bugs when deleting any item.
        yield setRenderItems(false);
        // Prevent removing last row. Turn back to default state instead.
        if (value.length === 1) {
            invalidRowsRef.current = [];
            yield updateValue([{}], { touched: false, forceErrorMessage: false });
        }
        else {
            yield updateValue(value.filter((_item, index) => index !== rowIndex));
        }
        setRenderItems(true);
    });
    return (react_1.default.createElement("div", { className: classes.root },
        renderItems
            ? value.map((fieldgroupValues, rowIndex) => react_1.default.createElement("div", { className: (0, classnames_1.default)('rfc-grouprow', classes.groupRow, {
                    [classes.groupRowError]: invalidRowsRef.current.includes(rowIndex),
                }), key: rowIndex },
                react_1.default.createElement(_1.default, { onChange: (updatedFields, hasErrors) => handleChange(updatedFields, hasErrors, rowIndex), fields: fields, allMandatory: true, isFieldGroup: true },
                    react_1.default.createElement(Children, { values: fieldgroupValues })),
                react_1.default.createElement("div", { className: classes.deleteWrapper },
                    react_1.default.createElement("button", { className: classes.delete, onClick: e => handleDelete(e, rowIndex), title: 'Delete' }, deleteIcon))))
            : null,
        react_1.default.createElement(MoreComponent, Object.assign({ onClick: () => updateValue([...value, {}]) }, moreComponentProps), moreLabel)));
};
const useStyles = (0, react_jss_1.createUseStyles)((theme) => ({
    root: {
        marginBottom: 10,
    },
    groupRow: {
        display: 'flex',
        borderColor: theme.colors.fill,
        borderStyle: 'solid',
        borderLeftWidth: 2,
        padding: 10,
        '& + &': {
            marginTop: -2,
        },
        '& > *:first-child': {
            flexGrow: 1,
        },
        '& .rfc-row, & .fc-form-control': {
            marginBottom: 10,
        },
    },
    groupRowError: {
        borderLeftColor: theme.colors.error,
    },
    deleteWrapper: {
        marginTop: -10,
        marginRight: -12,
        marginBottom: -10,
        marginLeft: 15,
        display: 'flex',
        alignItems: 'center',
        [(0, _1.breakpoint)(theme.breakpoints.sm)]: {
            marginLeft: 30,
        },
    },
    delete: {
        backgroundImage: 'none',
        backgroundColor: theme.colors.inputBorder,
        color: 'white',
        fontSize: theme.typography.inputFontSize,
        width: 30,
        height: 30,
        border: 'none',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '&:hover': {
            backgroundColor: theme.colors.inputText,
        },
    },
}));
exports.default = (0, _1.withFormControl)(FieldGroup);
